import React from 'react'

export default function Reset() {
  return (
    <div>Reset</div>
  )
}
